import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  addSvgIcons(): void {
    this.addIconToRegistry('bank', 'bank.svg');
  }

  private addIconToRegistry(name: string, path: string): void {
    const iconUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${window.location.origin}/assets/${path}`);
    this.iconRegistry.addSvgIcon(name, iconUrl);
  }
}
